export default "__VITE_ASSET__QsTG9_DT__"